
import React from 'react';
import { useLocation } from 'react-router-dom';
import Overview from './Overview';
import Pomodoro from './Pomodoro';
import Kanban from './Kanban';
import Eisenhower from './Eisenhower';

const Index = () => {
  const location = useLocation();

  // Route to the appropriate component based on pathname
  switch (location.pathname) {
    case '/pomodoro':
      return <Pomodoro />;
    case '/kanban':
      return <Kanban />;
    case '/eisenhower':
      return <Eisenhower />;
    // Never load TasksPage here (dedicated route at /tasks), always default to Overview
    default:
      return <Overview />;
  }
};

export default Index;
